/**
 * Bridge limits semantics:
 * - null  = unlimited
 * - 0     = feature not included in this plan
 * - N > 0 = hard cap at N
 */

export function withinLimit(
  limits: Record<string, number | null>,
  key: string,
  currentCount: number
): boolean {
  const limit = limits[key] ?? null;

  // Not set in limits object — treat as not restricted
  if (limit === undefined) {
    return true;
  }

  // Unlimited
  if (limit === null) {
    return true;
  }

  // Not included in plan
  if (limit === 0) {
    return false;
  }

  return currentCount < limit;
}

export function getRemainingCapacity(
  limits: Record<string, number | null>,
  key: string,
  currentCount: number
): number | null {
  const limit = limits[key] ?? null;

  // Unlimited
  if (limit === null) {
    return null;
  }

  // Not included
  if (limit === 0) {
    return 0;
  }

  const remaining = limit - currentCount;
  return remaining > 0 ? remaining : 0;
}
